var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result d-flex-1 flex-column m-10"},[_c('div',{staticClass:"d-flex-1 flex-column"})])}]

export { render, staticRenderFns }